export default __webpack_public_path__ + "static/media/bg-titre-header.46535a0b.webp";